var SettingsCtrl = function (gettextCatalog, user, AppUser, Notification) {
  this.model = user;
  this.modelPassword = {};
  this.gettextCatalog = gettextCatalog;
  this._AppUser = AppUser;
  this._Notification = Notification;
};

SettingsCtrl.prototype.changePassword = function () {
  var self = this;

  this
    ._AppUser
    .changePassword(
      this.modelPassword,
      function () {
        self._Notification.success(self.gettextCatalog.getString('Passwort geändert'));
      },
      function () {
        self._Notification.error(self.gettextCatalog.getString('Passwort konnte nicht geändert werden. Das alte Passwort war nicht korrekt.'));
      });

};

module.exports = SettingsCtrl;



// WEBPACK FOOTER //
// ./client/src/app/modules/settings/SettingsCtrl.js